<vim-core-widget-loader
  widgetTag="sky-widgets-settings"
  [inputs]="{ uiLanguage: uiLanguage$ | async }"
></vim-core-widget-loader>

<crm-progress-bar></crm-progress-bar>

<crm-header [user]="user"></crm-header>

<mat-sidenav-container class="sidenav-container">
  <mat-sidenav-content class="content crm-layout-width" [class.full-width]="isFullScreen" [class.padding]="withPadding">
    <router-outlet></router-outlet>

    <ng-template #bottomTemplate></ng-template>
  </mat-sidenav-content>
</mat-sidenav-container>
